 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AboutUs":"AboutUs","AddQuestion~Affiliate~Dashboard2~GradePaper~GradePapers~Paper~PaperCollection~PaperCreate~Papers~Pri~ebeff514":"AddQuestion~Affiliate~Dashboard2~GradePaper~GradePapers~Paper~PaperCollection~PaperCreate~Papers~Pri~ebeff514","AddQuestion~Collection~Dashboard2~Paper~PaperCollection~QuestionEditor~StartExercises~Subject~UploadQuestion":"AddQuestion~Collection~Dashboard2~Paper~PaperCollection~QuestionEditor~StartExercises~Subject~UploadQuestion","AddQuestion~BlogEditor~Dashboard2~Paper~QuestionEditor":"AddQuestion~BlogEditor~Dashboard2~Paper~QuestionEditor","AddQuestion~BlogEditor~Dashboard2~QuestionEditor":"AddQuestion~BlogEditor~Dashboard2~QuestionEditor","AddQuestion":"AddQuestion","Dashboard2":"Dashboard2","QuestionEditor":"QuestionEditor","GradePaper~Paper~PaperCollection~Papers~Pricing":"GradePaper~Paper~PaperCollection~Papers~Pricing","Paper":"Paper","Collections~Subject~UploadQuestion":"Collections~Subject~UploadQuestion","Subject~UploadQuestion":"Subject~UploadQuestion","Subject":"Subject","UploadQuestion":"UploadQuestion","AudioTest~Collection~PaperCollection":"AudioTest~Collection~PaperCollection","PaperCollection":"PaperCollection","Affiliate":"Affiliate","GradePapers":"GradePapers","AdminGeneratedPaper~GradePaper":"AdminGeneratedPaper~GradePaper","GradePaper":"GradePaper","Papers":"Papers","Pricing":"Pricing","PaperCreate":"PaperCreate","SignupPage":"SignupPage","AdminBlogs~BlogEditor":"AdminBlogs~BlogEditor","BlogEditor":"BlogEditor","Collection":"Collection","StartExercises":"StartExercises","AdminBlogs":"AdminBlogs","AdminGeneratedPaper~AdminGeneratedPapers":"AdminGeneratedPaper~AdminGeneratedPapers","AdminGeneratedPapers":"AdminGeneratedPapers","AdminGeneratedPaper":"AdminGeneratedPaper","AdminPreCollection":"AdminPreCollection","AdminPreCollections~AdminQuestion":"AdminPreCollections~AdminQuestion","AdminPreCollections":"AdminPreCollections","AdminQuestion":"AdminQuestion","AdminQuestionMonitor":"AdminQuestionMonitor","AudioTest":"AudioTest","Blog":"Blog","Blogs":"Blogs","CareerPath":"CareerPath","Collections":"Collections","Dashboard":"Dashboard","Enterprise":"Enterprise","FolderPage":"FolderPage","NotFound":"NotFound","PremiumCancel":"PremiumCancel","PremiumError":"PremiumError","PremiumSuccess":"PremiumSuccess","Profile":"Profile","Purchases":"Purchases","ResetPassword":"ResetPassword","Review":"Review","SigninPage":"SigninPage","Subjects":"Subjects","TermsAndPrivacy":"TermsAndPrivacy","UpdatePhoneNumber":"UpdatePhoneNumber","UploadQuestions":"UploadQuestions"}[chunkId]||chunkId) + "." + {"AboutUs":"d6dab1ee","AddQuestion~Affiliate~Dashboard2~GradePaper~GradePapers~Paper~PaperCollection~PaperCreate~Papers~Pri~ebeff514":"9be9dc9d","AddQuestion~Collection~Dashboard2~Paper~PaperCollection~QuestionEditor~StartExercises~Subject~UploadQuestion":"45ee40f5","AddQuestion~BlogEditor~Dashboard2~Paper~QuestionEditor":"58f55e33","AddQuestion~BlogEditor~Dashboard2~QuestionEditor":"e556be85","AddQuestion":"7aab13e1","Dashboard2":"bf199e87","QuestionEditor":"6b25fff8","GradePaper~Paper~PaperCollection~Papers~Pricing":"7f17a535","Paper":"835d587f","Collections~Subject~UploadQuestion":"23053ec2","Subject~UploadQuestion":"d1fe2396","Subject":"bf6ea9d6","UploadQuestion":"b1315e32","AudioTest~Collection~PaperCollection":"53e832ea","PaperCollection":"a93f27db","Affiliate":"6d96d5d5","GradePapers":"b25f41bd","AdminGeneratedPaper~GradePaper":"09fb06f1","GradePaper":"33b12dec","Papers":"74e22428","Pricing":"7e057a13","PaperCreate":"2ff40080","SignupPage":"2f909dd0","AdminBlogs~BlogEditor":"34538f69","BlogEditor":"677a4d27","Collection":"8eb51a35","StartExercises":"b0a34f01","AdminBlogs":"fc11a636","AdminGeneratedPaper~AdminGeneratedPapers":"5e157e06","AdminGeneratedPapers":"ad113539","AdminGeneratedPaper":"81de1642","AdminPreCollection":"8cafa5b3","AdminPreCollections~AdminQuestion":"bed5bef1","AdminPreCollections":"d17239b5","AdminQuestion":"bc8726f2","AdminQuestionMonitor":"ec126a8e","AudioTest":"a746eae9","Blog":"ab612ea6","Blogs":"707c4808","CareerPath":"41f1baa0","Collections":"da586b16","Dashboard":"464b17b4","Enterprise":"c2b9eeca","FolderPage":"d87f1687","NotFound":"5dccfc57","PremiumCancel":"946b0fa9","PremiumError":"1d258694","PremiumSuccess":"3efdb09b","Profile":"ab947c6e","Purchases":"63e896c3","ResetPassword":"23ef2ce0","Review":"bfe74c08","SigninPage":"cc44a004","Subjects":"ef39ffdb","TermsAndPrivacy":"a39f40dc","UpdatePhoneNumber":"90e63bca","UploadQuestions":"4d431241","chunk-369444a7":"dbc4bf2d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AboutUs":1,"AddQuestion~Affiliate~Dashboard2~GradePaper~GradePapers~Paper~PaperCollection~PaperCreate~Papers~Pri~ebeff514":1,"AddQuestion~Collection~Dashboard2~Paper~PaperCollection~QuestionEditor~StartExercises~Subject~UploadQuestion":1,"AddQuestion":1,"Dashboard2":1,"QuestionEditor":1,"GradePaper~Paper~PaperCollection~Papers~Pricing":1,"Paper":1,"Collections~Subject~UploadQuestion":1,"Subject~UploadQuestion":1,"Subject":1,"UploadQuestion":1,"PaperCollection":1,"Affiliate":1,"GradePaper":1,"Papers":1,"Pricing":1,"PaperCreate":1,"AdminBlogs~BlogEditor":1,"BlogEditor":1,"Collection":1,"AdminBlogs":1,"AdminGeneratedPaper~AdminGeneratedPapers":1,"AdminGeneratedPapers":1,"AdminGeneratedPaper":1,"AdminPreCollection":1,"AdminPreCollections~AdminQuestion":1,"AdminPreCollections":1,"AdminQuestion":1,"AudioTest":1,"Blog":1,"Blogs":1,"CareerPath":1,"Dashboard":1,"Enterprise":1,"NotFound":1,"Profile":1,"Purchases":1,"Review":1,"SigninPage":1,"Subjects":1,"UpdatePhoneNumber":1,"UploadQuestions":1,"chunk-369444a7":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AboutUs":"AboutUs","AddQuestion~Affiliate~Dashboard2~GradePaper~GradePapers~Paper~PaperCollection~PaperCreate~Papers~Pri~ebeff514":"AddQuestion~Affiliate~Dashboard2~GradePaper~GradePapers~Paper~PaperCollection~PaperCreate~Papers~Pri~ebeff514","AddQuestion~Collection~Dashboard2~Paper~PaperCollection~QuestionEditor~StartExercises~Subject~UploadQuestion":"AddQuestion~Collection~Dashboard2~Paper~PaperCollection~QuestionEditor~StartExercises~Subject~UploadQuestion","AddQuestion~BlogEditor~Dashboard2~Paper~QuestionEditor":"AddQuestion~BlogEditor~Dashboard2~Paper~QuestionEditor","AddQuestion~BlogEditor~Dashboard2~QuestionEditor":"AddQuestion~BlogEditor~Dashboard2~QuestionEditor","AddQuestion":"AddQuestion","Dashboard2":"Dashboard2","QuestionEditor":"QuestionEditor","GradePaper~Paper~PaperCollection~Papers~Pricing":"GradePaper~Paper~PaperCollection~Papers~Pricing","Paper":"Paper","Collections~Subject~UploadQuestion":"Collections~Subject~UploadQuestion","Subject~UploadQuestion":"Subject~UploadQuestion","Subject":"Subject","UploadQuestion":"UploadQuestion","AudioTest~Collection~PaperCollection":"AudioTest~Collection~PaperCollection","PaperCollection":"PaperCollection","Affiliate":"Affiliate","GradePapers":"GradePapers","AdminGeneratedPaper~GradePaper":"AdminGeneratedPaper~GradePaper","GradePaper":"GradePaper","Papers":"Papers","Pricing":"Pricing","PaperCreate":"PaperCreate","SignupPage":"SignupPage","AdminBlogs~BlogEditor":"AdminBlogs~BlogEditor","BlogEditor":"BlogEditor","Collection":"Collection","StartExercises":"StartExercises","AdminBlogs":"AdminBlogs","AdminGeneratedPaper~AdminGeneratedPapers":"AdminGeneratedPaper~AdminGeneratedPapers","AdminGeneratedPapers":"AdminGeneratedPapers","AdminGeneratedPaper":"AdminGeneratedPaper","AdminPreCollection":"AdminPreCollection","AdminPreCollections~AdminQuestion":"AdminPreCollections~AdminQuestion","AdminPreCollections":"AdminPreCollections","AdminQuestion":"AdminQuestion","AdminQuestionMonitor":"AdminQuestionMonitor","AudioTest":"AudioTest","Blog":"Blog","Blogs":"Blogs","CareerPath":"CareerPath","Collections":"Collections","Dashboard":"Dashboard","Enterprise":"Enterprise","FolderPage":"FolderPage","NotFound":"NotFound","PremiumCancel":"PremiumCancel","PremiumError":"PremiumError","PremiumSuccess":"PremiumSuccess","Profile":"Profile","Purchases":"Purchases","ResetPassword":"ResetPassword","Review":"Review","SigninPage":"SigninPage","Subjects":"Subjects","TermsAndPrivacy":"TermsAndPrivacy","UpdatePhoneNumber":"UpdatePhoneNumber","UploadQuestions":"UploadQuestions"}[chunkId]||chunkId) + "." + {"AboutUs":"0c94b939","AddQuestion~Affiliate~Dashboard2~GradePaper~GradePapers~Paper~PaperCollection~PaperCreate~Papers~Pri~ebeff514":"36c49ae7","AddQuestion~Collection~Dashboard2~Paper~PaperCollection~QuestionEditor~StartExercises~Subject~UploadQuestion":"082adfb1","AddQuestion~BlogEditor~Dashboard2~Paper~QuestionEditor":"31d6cfe0","AddQuestion~BlogEditor~Dashboard2~QuestionEditor":"31d6cfe0","AddQuestion":"c35eb81d","Dashboard2":"07f92fd9","QuestionEditor":"cf73269f","GradePaper~Paper~PaperCollection~Papers~Pricing":"86ec7d69","Paper":"b60d6b3b","Collections~Subject~UploadQuestion":"87e076f6","Subject~UploadQuestion":"9b7c1680","Subject":"4d624c6e","UploadQuestion":"4e5e150f","AudioTest~Collection~PaperCollection":"31d6cfe0","PaperCollection":"a3f5d329","Affiliate":"0de2defd","GradePapers":"31d6cfe0","AdminGeneratedPaper~GradePaper":"31d6cfe0","GradePaper":"7b5b73ad","Papers":"1d2da8c4","Pricing":"9cd0fa97","PaperCreate":"ed1d1c9e","SignupPage":"31d6cfe0","AdminBlogs~BlogEditor":"2722189b","BlogEditor":"630f9234","Collection":"1ba397be","StartExercises":"31d6cfe0","AdminBlogs":"f289b399","AdminGeneratedPaper~AdminGeneratedPapers":"b23cd323","AdminGeneratedPapers":"338571b8","AdminGeneratedPaper":"6689f7a7","AdminPreCollection":"d59aa87b","AdminPreCollections~AdminQuestion":"2722189b","AdminPreCollections":"8cd83335","AdminQuestion":"b33e215a","AdminQuestionMonitor":"31d6cfe0","AudioTest":"ffde2728","Blog":"45da181b","Blogs":"7c880352","CareerPath":"707ca79a","Collections":"31d6cfe0","Dashboard":"95fbbc64","Enterprise":"93a033e7","FolderPage":"31d6cfe0","NotFound":"d069c79e","PremiumCancel":"31d6cfe0","PremiumError":"31d6cfe0","PremiumSuccess":"31d6cfe0","Profile":"a27f313f","Purchases":"6eead62c","ResetPassword":"31d6cfe0","Review":"f09ccb74","SigninPage":"8a697168","Subjects":"1b31274c","TermsAndPrivacy":"31d6cfe0","UpdatePhoneNumber":"5055f2e4","UploadQuestions":"4e5e150f","chunk-369444a7":"52b902e7"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
